// eslint-disable-next-line import/prefer-default-export
export const USER_PAGE_SLUGS = {
  accountDetails: 'info',
  addresses: 'addresses',
  creditCards: 'cards',
  myloyalty: 'my-loyalty',
  notifications: 'notifications',
  orderDetails: 'order',
  ordersHistory: 'orders',
  pomeloCredits: 'credits',
  pomeloID: 'me',
  returnDetails: 'return',
  returnsHistory: 'returns',
  myAccount: 'my-account',
  myRewards: 'my-rewards',
}
